<template>
  <div v-if="isVisible" :class="[ 'flex flex-col gap-2.5', spaceTop ? 'mt-7' : '' ]">
    <info-text
      v-for="item in notifications"
      :key="item.id"
      :type="item.severity"
      :icon="item.icon"
      :link="item.link || ''"
      :closable="canClose"
      large
      @close="dismiss(item)"
    >
      {{ item.message }}
    </info-text>
  </div>
</template>

<script>
import InfoText from '@/ui/components/InfoText.vue';

export default {
  name: 'SystemLevelNotifications',
  components: {
    InfoText,
  },
  props: {
    spaceTop: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    notifications() {
      return this.$store.getters['inAppNotifications/list'];
    },
    isVisible() {
      return this.notifications.length > 0;
    },
    canClose() {
      return this.$root.isInOriginalCompany;
    },
  },
  methods: {
    dismiss(item) {
      this.$store.dispatch('inAppNotifications/dismiss', item)
        .catch(err => this.error(err));
    },
  },
};
</script>
